module.exports = __webpack_public_path__ + "static/androidBannerMasterpass1-49d9ba5f787f51171436b20986e1fe59.png";